import React from 'react'

import { useSearchParams } from 'shared/hooks/useSearchParams'

import { AuthView, SelectedUserView } from './views'

export const LoginPage = () => {
  const [{ user }] = useSearchParams<{ user?: string }>()

  return user ? <SelectedUserView /> : <AuthView />
}
